var b2 = "/static/3574b14ff4782361.png";

export { b2 as default };
//# sourceMappingURL=b_2.png.js.map
